var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":"","full-width":""}},[_c('v-content',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.mensagem))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }